<template>
	<div v-on="$listeners" class="file-info-card-wrapper">
		<div class="file-icon">
			<SvgIcons :fileUrl="formattedItem.fileUrl" isFile class="icon" />
		</div>
		<div class="file-info-wrapper ml-16">
			<div class="content text-overflow2" :class="{ 'padding-right': shouldShowTop }">
				{{ formattedItem.title || '-' }}
			</div>
			<div class="footer mt-8">
				<slot v-if="$slots.date" name="date" />
				<div v-else class="date">{{ formatDateFn(formattedItem.time) }}</div>

				<el-button size="small" type="primary" plain
					><em class="iconfont icon-dakaimima mr-4"></em>{{ $t('enterprise.previes') }}</el-button
				>
			</div>
			<div v-if="shouldShowTop" class="file-top">
				<div>{{ $t('enterprise.top-post') }}</div>
			</div>
		</div>
	</div>
</template>

<script setup>
import { computed } from 'vue';
import { dateFormatYearMonthDate } from '@/utils/format';

/**
 * 组件属性定义
 * @typedef {Object} Props
 * @property {Object} item - 原始数据对象
 * @property {Function} [formatter] - 可选的格式化函数，用于将原始数据转换为组件所需格式
 */
const props = defineProps({
	item: {
		type: Object,
		default: () => ({})
	},
	/**
	 * 格式化函数，用于字段重命名或数据转换
	 * @param {Object} rawItem - 原始数据对象
	 * @returns {Object} 返回的对象会与原始数据合并
	 * @example
	 * :formatter="data => ({ time: data.stime })"
	 */
	formatter: {
		type: Function,
		default: null
	}
});

const formattedItem = computed(() => {
	if (props.formatter && typeof props.formatter === 'function') {
		const formattedData = props.formatter(props.item);
		// 将格式化后的数据与原始数据合并，formatter 返回的字段优先级更高
		return { ...props.item, ...formattedData };
	}
	return props.item;
});

const shouldShowTop = computed(() => formattedItem.value?.isTop);
const formatDateFn = date => dateFormatYearMonthDate(date);
</script>

<style lang="less" scoped>
.file-info-card-wrapper {
	padding: 20px 16px;
	display: flex;
	cursor: pointer;

	&:hover {
		background: #f7f8fa;
	}

	.file-icon {
		width: 32px;
		height: 32px;

		.icon {
			width: 32px;
			height: 32px;
		}
	}
	.file-info-wrapper {
		flex: 1;
		width: 0;
		position: relative;
	}
	.file-top {
		position: absolute;
		top: 0;
		right: 0;
		height: 24px;
		display: flex;
		align-items: center;

		div {
			height: 20px;
			padding: 0 10px;
			line-height: 20px;
			background: #f23d3d;
			border-radius: 0 0 2px 2px;

			font-size: 12px;
			font-weight: 400;
			color: #ffffff;
		}
	}

	.content {
		font-size: 16px;
		font-weight: 500;
		line-height: 24px;
		color: #1d2129;
		height: 48px;

		&.padding-right {
			padding-right: 60px;
		}
	}
	.footer {
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
	.date {
		font-size: 14px;
		font-weight: 400;
		line-height: 18px;
		color: #4e5969;

		.one-line {
			display: block;
			max-width: 72%;
		}
	}
}
</style>
